module.exports = __webpack_public_path__ + "img/233.805b582b.png";